export default __webpack_public_path__ + "static/media/chevronUp.28bb44fd.svg";